// extracted by mini-css-extract-plugin
export default {"button":"StylePrimarySmallTrueDar_button__5gMjX","styleprimarySmalltrueDar":"StylePrimarySmallTrueDar_styleprimarySmalltrueDar__MOiJR"};